// Info-bulle personnalisée, appliquée automatiquement à tout élément qui a un attribut `title` (statique ou dynamique) :
// plus aucune info-bulle native du navigateur, sans rien à ajouter dans les templates.
// Principe : au survol, on lit le title, on le retire le temps du survol (sinon le navigateur affiche aussi la sienne)
// puis on le remet à la sortie. Une seule bulle (<div class="app-tooltip">, style dans public.global.styl) est réutilisée.
const DELAY = 250;
const GAP = 8;

export function installTooltips() {
    const tip = document.createElement("div");
    tip.className = "app-tooltip";
    tip.setAttribute("role", "tooltip");
    document.body.appendChild(tip);

    let current = null; // élément survolé dont le title est retiré
    let text = "";
    let timer;

    const place = () => {
        const rect = current.getBoundingClientRect();
        const tipRect = tip.getBoundingClientRect();
        const top = rect.top - tipRect.height - GAP >= GAP ? rect.top - tipRect.height - GAP : rect.bottom + GAP;
        const left = Math.min(Math.max(GAP, rect.left + rect.width / 2 - tipRect.width / 2), window.innerWidth - tipRect.width - GAP);
        tip.style.top = top + "px";
        tip.style.left = left + "px";
    };

    const hideBubble = () => {
        clearTimeout(timer);
        tip.classList.remove("visible");
    };

    // Sortie de l'élément : la bulle disparaît et son title lui est rendu (sauf si l'application en a déjà remis un autre)
    const release = () => {
        hideBubble();
        if (current && !current.hasAttribute("title")) current.setAttribute("title", text);
        current = null;
    };

    document.addEventListener("mouseover", event => {
        if (!(event.target instanceof Element)) return;
        if (current && current.contains(event.target) && !event.target.closest("[title]")) return;
        const element = event.target.closest("[title]");
        if (!element || element === current) return;
        release();
        const title = element.getAttribute("title");
        if (!title || !title.trim()) return;
        current = element;
        text = title;
        element.removeAttribute("title");
        timer = setTimeout(() => {
            tip.textContent = text;
            tip.classList.add("visible");
            place();
        }, DELAY);
    });

    document.addEventListener("mouseout", event => {
        if (current && !(event.relatedTarget instanceof Node && current.contains(event.relatedTarget))) release();
    });

    // Un clic, un défilement ou une touche masquent la bulle (le title n'est rendu qu'à la sortie de l'élément)
    ["mousedown", "keydown", "scroll", "wheel"].forEach(name => document.addEventListener(name, hideBubble, true));
}
